import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import PageNotFoundImage from "shared/dist/assets/images/pageNotFound.png";
import { loginActions } from "../Services/Redux/actionCreators/userActions";
import { SNETStatusBanner } from "shared/dist/components";
import { Router } from "./routeUtils";
import { initializeApplication } from "../Services/Redux/actionCreators/userActions/loginActions";

const GlobalRouter = () => {
    const dispatch = useDispatch();
    const { isInitialized, isLoggedIn, error } = useSelector(
        (state) => ({
            isInitialized: state.user.isInitialized,
            isLoggedIn: state.user.isLoggedIn,
            error: state.error.app,
        }),
        shallowEqual
    );

    useEffect(() => {
        dispatch(initializeApplication());
    }, [dispatch]);

    if (error) {
        return (
            <SNETStatusBanner
                title="Unable to initialize application!"
                img={PageNotFoundImage}
                description="Unable to initialize the application. Please reload or contact support for help"
                actions={[
                    {
                        children: "reload",
                        variant: "contained",
                        color: "primary",
                        onClick: () => window.location.reload(),
                    },
                    {
                        children: "contact support",
                        variant: "contained",
                        color: "primary",
                        href: `mailto:${process.env.REACT_APP_SNET_SUPPORT_MAIL}`,
                    },
                    {
                        children: "sign out",
                        variant: "contained",
                        color: "primary",
                        onClick: () => dispatch(loginActions.signout),
                    },
                ]}
            />
        );
    }

    if (!isInitialized) {
        return <LinearProgress />;
    }

    return <Router isAuthenticated={isLoggedIn} />;
};

export default GlobalRouter;
